import React, { useEffect, useMemo, useState } from "react";
import Table from "../../components/utils/Table";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import CardLayout from "../../components/utils/CardLayout";
import SimListActions from "../../redux/inventory/purchaseSim/actions";
import genericActions from "../../redux/generic/actions";
import Modal from '../../components/utils/Modal'

const { getSimList: fetchSimList } = SimListActions;
const { getVendor, getACode } = genericActions;


const User = () => {
  const dispatch = useDispatch();
  const { simList, getSimListLoading, getSimListError } = useSelector((state) => state.purchaseSim);
  const { vendorList, aCodeList } = useSelector((state) => state.generic)
  const [searchItem, setSearchItem] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [showEmail, setShowEmail] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
      userId: '',
      roleId: '',
      dealerId: '',
      isActive: true
    },
  });

  const generateUserId = () => {
    const prefix = "USR";
    const digits = new Uint8Array(12);

    crypto.getRandomValues(digits);

    const randomDigits = Array.from(
      digits,
      (value) => value % 10
    ).join("");

    return `${prefix}${randomDigits}`;
  };

  useEffect(() => {
    regenerateUserId()
  }, [])

  const maskEmail = (email) => {
    if (!email) return "";
    const atIndex = email.indexOf("@");
    if (atIndex === -1) {
      if (email.length <= 1) return email;
      return email.charAt(0) + "*".repeat(email.length - 1);
    }

    const username = email.substring(0, atIndex);
    const domain = email.substring(atIndex);

    if (username.length <= 1) {
      return username + domain;
    }

    return (
      username.charAt(0) +
      "*".repeat(username.length - 1) +
      domain
    );
  };

  const filteredItems = useMemo(() => {
    return Array.isArray(simList)
      ? simList.filter(item => {
        if (!searchItem) return true;

        return Object.values(item).some(
          val =>
            typeof val === "string" &&
            val.toLowerCase().includes(searchItem.toLowerCase())
        );
      })
      : [];
  }, [simList, searchItem]);

  const regenerateUserId = async () => {
    const newUId = await generateUserId()
    setValue('userId', newUId)
  };

  const dataSource = filteredItems.map((item, key) => ({
    key: key + 1,
    serialNumber: item?.SerialNumber,
    purchaseNumber: item?.PurchaseNumber,
    createdDate: item?.CreatedDateTime,
    expireDate: item?.ExpireDate,
    inventoryStatus: item?.InventoryStatus,
    simType: item?.SIMType,
  }));

  const column = [
    { displayName: "User ID", key: "distributorId", },
    { displayName: "Email Address", key: "emailId", },
    { displayName: "Created Date", key: "createdDate", },
    { displayName: "Status", key: "status", },
    { displayName: "Action", key: "action", },
  ];

  // useEffect(() => {
  //   dispatch(getVendor());
  //   dispatch(getACode());
  //   dispatch(
  //     fetchSimList({
  //       networkID: 0,
  //       distributorId: 0,
  //       purchaseCode: "",
  //     }),
  //   );
  // }, [dispatch]);

  const handleReset = () => {
    reset();
    setShowPassword(false);
  };

  const handleSearch = (data) => {
    data.distributorId = Number(data.distributorId || 0)
    data.networkID = Number(data.networkID || 0)
    dispatch(fetchSimList(data));
  };


  const downloadResponseFile = () => {
    const data = dataSource.map((item, key) => (
      {
        key: key + 1,
        "Serial Number": item?.SerialNumber,
        "Created Date Time": item?.CreatedDateTime,
        "Expire Date": item?.ExpireDate,
        "Purchase Number": item?.PurchaseNumber,
        "Inventory Status": item?.InventoryStatus,
        "Type": item?.SIMType,
      }));

    downloadExcelSampleFile(data, "sim-list.xlsx");
  }

  const handleAddUpdateDealer = () => {
    // reset();
    setEmailInput("");
    setShowEmail(true);
    setShowPassword(false);
    setIsOpenModal(true);
  }

  const closeModal = () => {
    setIsOpenModal(false);
    reset({
      email: "",
      password: "",
      isActive: false,
    });
    setEmailInput("");
    setShowEmail(true);
    setShowPassword(false);
  }

  const handleAddUpdateDealerSubmit = (data) => {
    console.log(data.email);
    // const payload = {
    //   dealerId: dealerId,
    //   userId: userId,
    //   email: data.email,
    //   password: data.password,
    // };
  }

  return (
    <CardLayout title="User" icon="fas fa-users"
      rightContent={
        <div className="d-flex gap-2">
          <Button
            title="Excel"
            buttonType="button"
            variant="secondary"
            icon={<i className="ri-download-cloud-line me-2"></i>}
            onClick={downloadResponseFile}
          />
          <Button
            title="Add User"
            buttonType="button"
            variant="primary"
            icon={<i className="ri-add-line me-1"></i>}
            onClick={handleAddUpdateDealer}
          />
        </div>}
    >
      <div className="row mb-3">


        {/* Second Row */}
        <div className="col-lg-3 col-md-4 d-flex align-items-end gap-3" style={{ height: '70px' }}>
          <input
            type="search"
            className="form-control"
            placeholder="Search..."
            onChange={(e) => setSearchItem(e.target.value)}
          />
        </div>
      </div>
      {/* Table */}
      <div>
        <Table
          columns={column}
          loading={getSimListLoading}
          data={dataSource}
          pagination={true}
        // tableHeight="280px"
        />
      </div>
      <Modal
        showModal={isOpenModal}
        title="Add User"
        onHide={closeModal}
        onSaveChanges={handleAddUpdateDealerSubmit}
        width={700}
        showFooter={false}
        submitButtonTitle="Submit"
        submitBtnType='submit'
      >
        <form className="row" onSubmit={handleSubmit(handleAddUpdateDealerSubmit)}>
          {/* User ID */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              User ID{" "}
              <small style={{ fontSize: "10px" }}>(Auto-Generated)</small>
              <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <input
                type="text"
                className="form-control bg-light"
                {...register("userId")}
                readOnly
                disabled
              />
              <span
                className="input-group-text bg-white"
                onClick={regenerateUserId} title="Generate User ID" style={{ cursor: "pointer" }}>
                <i className="ri-refresh-line"></i></span>
            </div>
          </div>
          {/* Email Address */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Email Address{" "}
              <small style={{ fontSize: "10px" }}>
                (Used only for password reset)
              </small>
              <span className="text-danger">*</span>
            </label>

            <div className="input-group">
              <input
                type="text"
                placeholder="Enter email address"
                className={`form-control ${errors.email ? "is-invalid" : ""
                  }`}
                value={showEmail ? emailInput : maskEmail(emailInput)}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase();

                  setEmailInput(value);

                  setValue("email", value, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });

                  if (!value) {
                    setError("email", {
                      type: "required",
                      message: "Email Address is required",
                    });
                  } else if (
                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
                  ) {
                    setError("email", {
                      type: "pattern",
                      message: "Please enter a valid email address",
                    });
                  } else {
                    clearErrors("email");
                  }
                }}
              />
              <button
                type="button"
                className="input-group-text"
                onClick={() => {
                  setShowEmail((prev) => !prev);
                }}
                style={{
                  cursor: "pointer",
                  backgroundColor: "var(--bg-content)",
                  borderColor: "var(--border-color)",
                  color: "var(--hedging-text-color)",
                  minWidth: "42px",
                  justifyContent: "center",
                }}
                title={showEmail ? "Hide Email" : "Show Email"}
              >
                <i
                  className={
                    showEmail
                      ? "ri-eye-off-line"
                      : "ri-eye-line"
                  }
                  style={{ fontSize: "18px" }}
                />
              </button>
            </div>

            {errors.email && (
              <div className="invalid-feedback d-block">
                {errors.email.message}
              </div>
            )}
          </div>
          {/* Role */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Role
            </label>

            <select
              className={`form-select`}
              // disabled
              {...register("networkID")}
            >
              <option value="">Select Role</option>
              {/* {roleList?.map((item) => (
                  <option key={item.RoleID} value={item.RoleID}>
                    {item.RoleName}
                  </option>
                ))} */}
            </select>
          </div>
          {/* Dealer */}
          <div className="form-group col-md-6 mb-3">
            <label className="form-label fw-semibold">
              Dealer
            </label>

            <select
              className={`form-select`}
              // disabled
              {...register("networkID")}
            >
              <option value="">Select Dealer</option>
              {/* {roleList?.map((item) => (
                  <option key={item.RoleID} value={item.RoleID}>
                    {item.RoleName}
                  </option>
                ))} */}
            </select>
          </div>

          {/* Is Active */}
          <div className="form-group col-md-6 mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="isActiveCheck"
                {...register("isActive")}
              />

              <label
                className="form-check-label fw-semibold"
                htmlFor="isActiveCheck"
              >
                Is Active
              </label>
            </div>
          </div>

          {/* Buttons */}
          <div className="form-group col-12 mt-4 d-flex justify-content-end align-items-center gap-3">
            <Button
              title="Close"
              buttonType="button"
              variant="secondary"
              onClick={closeModal}
              icon={<i className="ri-close-circle-line me-1"></i>}
            />

            <Button
              title="Submit"
              buttonType="submit"
              variant="primary"
              icon={<i className="ri-send-plane-fill me-1"></i>}
            />
          </div>

        </form>
      </Modal>
    </CardLayout>
  );
};
export default User;
